/* ==========================================================================
   Nette Aufkleber – Auffrischung Herbst 2026
   Hereinfliegen, Parallaxe, Sale-Badges, Flug in den Warenkorb, „Passt dazu“.
   Kein Fremdcode, keine Bibliothek. Läuft auch, wenn Teile der Seite fehlen.
   ========================================================================== */
(function () {
  'use strict';

  var html = document.documentElement;
  var spaet = html.classList.contains('na-notausgang'); // Skript kam erst nach dem Notausgang
  html.classList.add('na-bereit');

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (ruhig) html.classList.add('na-ruhig');

  // Vorschau-Elemente (Sale vor dem Start) nur im unveröffentlichten Theme zeigen
  try {
    if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') {
      html.classList.add('na-vorschau-an');
    }
  } catch (e) { /* bleibt aus */ }

  /* ------------------------------------------------------------------------
     Hereinfliegen beim Scrollen
     Nur Elemente, die beim Laden noch unterhalb des Bildschirms liegen, werden
     erst versteckt. Was schon zu sehen ist, bleibt stehen (kein Flackern).
     ------------------------------------------------------------------------ */
  var beobachter = null;

  function markiere(el, klasse, verzug) {
    if (!el || el.__naMarkiert) return;
    el.__naMarkiert = true;
    var rr = el.getBoundingClientRect();
    if (spaet || ruhig || rr.top < window.innerHeight * 0.92) return;
    // seitlich außerhalb (Schiebe-Reihen): nicht verstecken, sonst stehen beim Wischen leere Plätze da
    if (rr.left >= window.innerWidth || rr.right <= 0) return;
    el.classList.add('na-reveal');
    if (klasse) el.classList.add(klasse);
    el.style.setProperty('--na-d', String(verzug || 0));
    if (beobachter) beobachter.observe(el);
  }

  function badgeBeobachten(el, verzug) {
    if (!el || el.__naBadge) return;
    el.__naBadge = true;
    el.style.setProperty('--na-d', String(verzug || 0));
    if (spaet || ruhig || !beobachter) { el.classList.add('na-in'); return; }
    beobachter.observe(el);
  }

  function sammeln(wurzel) {
    wurzel = wurzel || document;
    // Abschnittsüberschriften
    wurzel.querySelectorAll('.shopify-section h2:not(.na-hero__titel), .na-laufband__titel').forEach(function (h) {
      markiere(h, 'na-reveal--titel', 0);
    });
    // Produktkarten gestaffelt je Gruppe
    var gruppen = new Map();
    wurzel.querySelectorAll('product-card').forEach(function (karte) {
      var gruppe = karte.closest('.swiper-wrapper, ul, .grid, .shopify-section') || document.body;
      var i = gruppen.get(gruppe) || 0;
      gruppen.set(gruppe, i + 1);
      markiere(karte, null, (i % 4) * 110);
    });
    // Sale-Badges
    var b = 0;
    wurzel.querySelectorAll('[data-na-badge]').forEach(function (badge) {
      badgeBeobachten(badge, (b++ % 4) * 140 + 250);
    });
  }

  if ('IntersectionObserver' in window) {
    beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('na-in');
        beobachter.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }

  function start() {
    sammeln(document);

    // Nachgeladene Inhalte (Warenkorb, Vorschläge, Endlos-Liste) ebenfalls versorgen
    var mo = new MutationObserver(function (liste) {
      liste.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('[data-na-badge]')) badgeBeobachten(n, 0);
          if (n.className && String(n.className).indexOf('jdgm') !== -1) bewertungen(n);
          if (n.querySelectorAll) {
            n.querySelectorAll('[data-na-badge]').forEach(function (bd) { badgeBeobachten(bd, 0); });
            if (n.querySelector && n.querySelector('product-card')) sammeln(n);
          }
        });
      });
      leereVorschlaegeVerstecken();
    });
    mo.observe(document.body, { childList: true, subtree: true });

    heroTitel();
    kopfLeiste();
    judgemeFenster();
    produktSeite();
    kategorieText();
    instaKarussell();
    bewertungen(document);
    leereVorschlaegeVerstecken();
  }

  /* ------------------------------------------------------------------------
     Titelbild: Die Frau bewegt sich EINMAL am Anfang und steht dann still.
     Das kurze Video liegt nur über ihrem Bereich. Es wird sofort komplett geladen
     (der Kopf der Seite hat es schon vorgeladen) und startet erst, wenn es ganz
     da ist – sonst bleibt einfach das Foto stehen. Beim Scrollen ändert sich an
     ihr nichts. Nur Überschrift-Streifen und schwebende Aufkleber bewegen sich.
     ------------------------------------------------------------------------ */
  function heroTitel() {
    var hero = document.querySelector('[data-na-hero]');
    if (!hero) return;
    heroFilm(hero);
    if (ruhig) return;
    var schweber = Array.prototype.slice.call(hero.querySelectorAll('[data-na-speed]'));
    var worte = Array.prototype.slice.call(hero.querySelectorAll('.na-wort'));
    var laeuft = false;
    function rechnen() {
      laeuft = false;
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var y = Math.max(0, -r.top);
      // Überschrift reagiert auf den Scroll der Seite, nicht erst, wenn das Titelbild oben anstößt
      var s = Math.max(0, window.scrollY || window.pageYOffset || 0);
      worte.forEach(function (w, i) {
        var tempo = 0.18 + (i % 3) * 0.14;
        var dreh = (i % 2 ? 1 : -1) * Math.min(14, s * 0.025 * (1 + (i % 3) * 0.4));
        w.style.translate = '0 ' + (-s * tempo).toFixed(1) + 'px';
        w.style.rotate = dreh.toFixed(2) + 'deg';
      });
      schweber.forEach(function (el, i) {
        var v = parseFloat(el.getAttribute('data-na-speed')) || 0.4;
        el.style.setProperty('--py', (-y * v).toFixed(1) + 'px');
        el.style.setProperty('--pr', ((i % 2 ? 1 : -1) * y * 0.03).toFixed(2) + 'deg');
      });
    }
    var anstossen = function () {
      if (!laeuft) { laeuft = true; requestAnimationFrame(rechnen); }
    };
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen);
    rechnen();
  }

  function heroFilm(hero) {
    var film = hero.querySelector('video[data-na-film]');
    var bild = hero.querySelector('.na-hero__zoom .na-hero__img');
    var zoom = hero.querySelector('.na-hero__zoom');
    if (!film || !bild || !zoom) return;
    var sparen = navigator.connection && navigator.connection.saveData;
    if (ruhig || sparen || !window.fetch || !window.URL || !URL.createObjectURL) { film.remove(); return; }

    var zahlen = function (attr) { return (film.getAttribute(attr) || '').trim().split(/\s+/).map(parseFloat); };
    var lage = zahlen('data-na-film-lage'); // Bereich der Frau im ganzen Foto (Anteile)
    var ausschnittM = zahlen('data-na-ausschnitt-m'); // was das Telefon-Bild vom ganzen Foto zeigt
    var telefon = window.matchMedia('(max-width: 749px)');

    // Lage des Videos = Lage ihres Bereichs im angezeigten Foto (object-fit: cover + object-position)
    function platzieren() {
      var nw = bild.naturalWidth, nh = bild.naturalHeight;
      var W = zoom.offsetWidth, H = zoom.offsetHeight;
      if (!nw || !nh || !W || !H || lage.length < 4) return false;
      var a = telefon.matches && ausschnittM.length === 4 ? ausschnittM : [0, 0, 1, 1];
      var pos = getComputedStyle(bild).objectPosition.split(' ');
      var px = /%$/.test(pos[0]) ? parseFloat(pos[0]) / 100 : 0.5;
      var py = /%$/.test(pos[1] || '') ? parseFloat(pos[1]) / 100 : 0.5;
      var s = Math.max(W / nw, H / nh);
      var dw = nw * s, dh = nh * s;
      var ox = (W - dw) * px, oy = (H - dh) * py;
      film.style.left = (ox + (lage[0] - a[0]) / a[2] * dw).toFixed(2) + 'px';
      film.style.top = (oy + (lage[1] - a[1]) / a[3] * dh).toFixed(2) + 'px';
      film.style.width = (lage[2] / a[2] * dw).toFixed(2) + 'px';
      film.style.height = (lage[3] / a[3] * dh).toFixed(2) + 'px';
      return true;
    }

    var t0 = performance.now();
    // Der Abschnitt hat den Film meist schon angefordert (Inline-Skript direkt am Video) – den Abruf übernehmen
    var frueh = window.__naFilm && window.__naFilm.adresse === film.getAttribute('data-na-film') ? window.__naFilm : null;
    var abbruch = frueh ? frueh.abbruch : (window.AbortController ? new AbortController() : null);
    var frist = setTimeout(function () { if (abbruch) abbruch.abort(); aufgeben(); }, 4000);
    var adresse = null;
    var erledigt = false;
    function aufgeben() {
      if (erledigt) return;
      erledigt = true;
      clearTimeout(frist);
      film.classList.remove('ist-an');
      setTimeout(function () {
        film.removeAttribute('src');
        try { film.load(); } catch (e) { /* egal */ }
        if (adresse) URL.revokeObjectURL(adresse);
        film.remove();
      }, 260);
    }
    var fotoDa = bild.complete && bild.naturalWidth ? Promise.resolve() : new Promise(function (ok) {
      bild.addEventListener('load', ok, { once: true });
      bild.addEventListener('error', ok, { once: true });
    });

    (frueh ? frueh.blob : fetch(film.getAttribute('data-na-film'), abbruch ? { signal: abbruch.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error('Film ' + r.status); return r.blob(); }))
      .then(function (blob) {
        adresse = URL.createObjectURL(blob);
        film.src = adresse;
        return new Promise(function (ok, nein) {
          if (film.readyState >= 3) return ok();
          film.addEventListener('canplaythrough', ok, { once: true });
          film.addEventListener('error', nein, { once: true });
          film.load();
        });
      })
      .then(function () { return fotoDa; })
      .then(function () {
        if (erledigt) return;
        // Nur, wenn das Titelbild noch zu sehen ist – sonst bleibt das Foto einfach stehen
        var r = hero.getBoundingClientRect();
        if (r.bottom < 80 || r.top > window.innerHeight) return aufgeben();
        if (!platzieren()) return aufgeben();
        clearTimeout(frist);
        // kurze Atempause nach dem ersten Bild, damit es nicht hektisch wirkt
        var warten = Math.max(0, 450 - (performance.now() - t0));
        setTimeout(function () {
          if (erledigt) return;
          film.addEventListener('playing', function () { film.classList.add('ist-an'); }, { once: true });
          film.addEventListener('ended', aufgeben, { once: true });
          var p = film.play();
          if (p && p.catch) p.catch(aufgeben); // z. B. Stromsparmodus am iPhone: Foto bleibt
        }, warten);
      })
      .catch(aufgeben);

    // Läuft der Film schon und wechselt das Foto (Drehen über die 750-px-Grenze) oder lässt sich die Lage nicht
    // berechnen, hört er auf – sonst stünde kurz eine zweite, verzerrte Frau über dem Foto
    var umbau = function () {
      if (erledigt) return;
      if (!platzieren() && film.classList.contains('ist-an')) aufgeben();
    };
    window.addEventListener('resize', umbau);
    bild.addEventListener('load', umbau);
    var wechsel = function () { if (!erledigt && film.classList.contains('ist-an')) aufgeben(); };
    if (telefon.addEventListener) telefon.addEventListener('change', wechsel); else if (telefon.addListener) telefon.addListener(wechsel);
  }

  /* ------------------------------------------------------------------------
     Menüleiste: Logo klebt sich beim ersten Aufruf einer Sitzung einmal auf,
     der Warenkorb wackelt, sobald die Zahl darin steigt.
     ------------------------------------------------------------------------ */
  function kopfLeiste() {
    if (ruhig) return;
    try {
      if (!sessionStorage.getItem('na-logo')) {
        html.classList.add('na-logo-erst');
        sessionStorage.setItem('na-logo', '1');
        setTimeout(function () { html.classList.remove('na-logo-erst'); }, 1200);
      }
    } catch (e) { /* ohne Speicher: kein Aufkleben, kein Fehler */ }

    var korbPlatz = document.querySelector('.header__utils-item--cart');
    if (!korbPlatz || !window.MutationObserver) return;
    var zahl = function () {
      var b = korbPlatz.querySelector('.cart-count-badge');
      return b ? parseInt(b.textContent, 10) || 0 : 0;
    };
    var bisher = zahl();
    new MutationObserver(function () {
      var jetzt = zahl();
      if (jetzt > bisher) {
        var link = korbPlatz.querySelector('.header__utils-link--cart');
        if (link) {
          link.classList.remove('na-wackelt');
          void link.offsetWidth; // Animation neu starten
          link.classList.add('na-wackelt');
          setTimeout(function () { link.classList.remove('na-wackelt'); }, 900);
        }
      }
      bisher = jetzt;
    }).observe(korbPlatz, { childList: true, subtree: true, characterData: true });
  }

  /* ------------------------------------------------------------------------
     Judge.me-Fenster: englische Reste auf Deutsch, toter Link zur Bewertungsseite,
     kleine Fenster ziehen sich beim Schließen wie ein Aufkleber ab.
     ------------------------------------------------------------------------ */
  var JDGM_TEXTE = {
    'Write a review': 'Bewertung schreiben',
    'Lassen Sie Kunden für uns sprechen': 'Das sagt ihr über uns',
    'Let customers speak for us': 'Das sagt ihr über uns',
    'Customer Reviews': 'Kundenbewertungen',
    'Verified': 'Verifiziert',
    'Sort by': 'Sortieren',
    'Most Recent': 'Neueste',
    'Cancel review': 'Abbrechen',
    'Submit Review': 'Bewertung absenden'
  };
  var JDGM_LABEL = {
    'Close popup widget': 'Schließen',
    'Click to open Judge.me floating reviews tab': 'Alle Bewertungen öffnen',
    'Review picture': 'Foto zur Bewertung'
  };
  function judgemeDeutsch(wurzel) {
    var alle = wurzel.querySelectorAll('[class*="jdgm"]');
    for (var i = 0; i < alle.length; i++) {
      var el = alle[i];
      if (el.children.length === 0) {
        var roh = el.textContent.trim();
        if (JDGM_TEXTE[roh]) el.textContent = JDGM_TEXTE[roh];
        else {
          var m = /^Based on (\d+) reviews?$/.exec(roh);
          if (m) el.textContent = 'Basierend auf ' + m[1] + ' Bewertungen';
        }
      }
      ['aria-label', 'title', 'alt'].forEach(function (a) {
        var v = el.getAttribute(a);
        if (v && JDGM_LABEL[v]) el.setAttribute(a, JDGM_LABEL[v]);
      });
      if (el.tagName === 'A') {
        var h = el.getAttribute('href') || '';
        if (/\/pages\/reviews(?:[?#]|$)/.test(h)) el.setAttribute('href', h.replace('/pages/reviews', '/pages/bewertungen'));
      }
    }
  }
  function judgemeFenster() {
    judgemeDeutsch(document);
    if (window.MutationObserver) {
      var wartet = false;
      new MutationObserver(function (liste) {
        if (wartet) return;
        for (var i = 0; i < liste.length; i++) {
          var z = liste[i].target;
          if (z.nodeType === 1 && (String(z.className).indexOf('jdgm') > -1 || (z.querySelector && z.querySelector('[class*="jdgm"]')))) {
            wartet = true;
            requestAnimationFrame(function () { wartet = false; judgemeDeutsch(document); });
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (ruhig) return;
    // Schließen: Judge.me schließt sofort selbst – eine Kopie zieht sich dabei sichtbar ab
    document.addEventListener('click', function (e) {
      var knopf = e.target.closest && e.target.closest('.jdgm-popup-card__close-btn');
      if (!knopf) return;
      var karte = knopf.closest('.jdgm-popup-card');
      if (!karte) return;
      var r = karte.getBoundingClientRect();
      if (!r.width) return;
      var huelle = document.createElement('div');
      huelle.className = 'jdgm-popup-widget__cards-container na-abzieh-huelle';
      huelle.setAttribute('aria-hidden', 'true');
      var kopie = karte.cloneNode(true);
      kopie.classList.remove('active-popup-card');
      kopie.classList.add('na-abziehen');
      kopie.style.cssText = 'position:fixed;left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px;margin:0;display:' + getComputedStyle(karte).display + ';';
      huelle.appendChild(kopie);
      document.body.appendChild(huelle);
      // Das echte Fenster sofort unsichtbar – Judge.me entfernt es erst gut 0,5 s später, sonst sähe man zwei Fenster
      // mit !important: die Einblend-Animation der Karte (… both) würde eine normale Deckkraft überstimmen,
      // und ohne Übergang: Judge.me gibt der Karte „transition: all“, sonst bliebe sie 0,6 s lang sichtbar
      karte.style.setProperty('transition', 'none', 'important');
      karte.style.setProperty('opacity', '0', 'important');
      setTimeout(function () { huelle.remove(); }, 360);
      setTimeout(function () { karte.style.removeProperty('opacity'); karte.style.removeProperty('transition'); }, 1200);
    }, true);
  }

  /* ------------------------------------------------------------------------
     Produktseite: Aufkleber kippt mit der Maus, Kaufleiste, Abschnitte
     ------------------------------------------------------------------------ */
  function sanft(el, verzug) {
    if (!el || el.__naMarkiert) return;
    el.__naMarkiert = true;
    if (spaet || ruhig || !beobachter) return;
    if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
    el.classList.add('na-reveal--sanft');
    el.style.setProperty('--na-d', String(verzug || 0));
    beobachter.observe(el);
  }

  function produktSeite() {
    if (!document.body.classList.contains('template--product')) return;

    // Fragen und Bewertungen fliegen nacheinander herein
    document.querySelectorAll('.section-accordions details, .section-accordions .accordion__section').forEach(function (el, i) {
      sanft(el.closest('accordion-default') || el, (i % 4) * 90);
    });
    document.querySelectorAll('[id$="__na_bewertungen"] .app-embeds').forEach(function (el) { sanft(el, 0); });

    // 3D-Kippen mit Glanzlicht – nur mit echter Maus
    var buehne = document.querySelector('.main-product__media');
    var maus = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (buehne && maus && !ruhig) {
      var aktiv = null;
      buehne.addEventListener('pointermove', function (e) {
        var m = e.target.closest && e.target.closest('.media');
        if (!m) return;
        if (aktiv && aktiv !== m) loslassen();
        aktiv = m;
        var r = m.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        m.style.setProperty('--na-kx', (-y * 12).toFixed(2) + 'deg');
        m.style.setProperty('--na-ky', (x * 14).toFixed(2) + 'deg');
        m.style.setProperty('--na-gx', ((x + 0.5) * 100).toFixed(1) + '%');
        m.style.setProperty('--na-gy', ((y + 0.5) * 100).toFixed(1) + '%');
        m.classList.add('na-kippt');
      });
      var loslassen = function () {
        if (!aktiv) return;
        aktiv.classList.remove('na-kippt');
        aktiv.style.setProperty('--na-kx', '0deg');
        aktiv.style.setProperty('--na-ky', '0deg');
        aktiv = null;
      };
      buehne.addEventListener('pointerleave', loslassen);
    }

    // Kaufleiste: sichtbar, sobald der Kaufknopf oben aus dem Bild ist
    var leiste = document.querySelector('.product__sticky-cart');
    var kauf = document.querySelector('.product__buy-buttons .product-form__buttons');
    if (leiste && kauf) {
      // Direkt messen statt beobachten: beim schnellen Wischen springt die Seite sonst über den Knopf hinweg
      html.classList.add('na-leiste-js');
      var leisteWartet = false;
      var leistePruefen = function () {
        leisteWartet = false;
        var an = kauf.getBoundingClientRect().bottom < 0;
        html.classList.toggle('na-leiste-an', an);
        if (an) html.style.setProperty('--na-leiste-h', leiste.offsetHeight + 'px');
      };
      var leisteMelden = function () {
        if (!leisteWartet) { leisteWartet = true; requestAnimationFrame(leistePruefen); }
      };
      window.addEventListener('scroll', leisteMelden, { passive: true });
      window.addEventListener('resize', leisteMelden);
      leistePruefen();
    }
  }

  /* ------------------------------------------------------------------------
     Kategorieseite: langer Einleitungstext am Telefon erst gekürzt
     ------------------------------------------------------------------------ */
  function kategorieText() {
    var text = document.querySelector('.template--collection .section-page-banner__text');
    if (!text) return;
    text.parentNode.classList.add('na-text-kurz');
    requestAnimationFrame(function () {
      if (text.scrollHeight <= text.clientHeight + 4) return;
      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'na-mehr';
      knopf.textContent = 'Mehr lesen';
      knopf.setAttribute('aria-expanded', 'false');
      knopf.addEventListener('click', function () {
        var offen = text.classList.toggle('na-offen');
        knopf.textContent = offen ? 'Weniger' : 'Mehr lesen';
        knopf.setAttribute('aria-expanded', String(offen));
      });
      text.parentNode.insertBefore(knopf, text.nextSibling);
    });
  }

  /* ------------------------------------------------------------------------
     Judge.me: deutsches Datum, große Durchschnittszahl, Sterne führen zu den Bewertungen
     ------------------------------------------------------------------------ */
  // US-Datum (09/24/2026) → 24.09.2026 – nur ändern, was noch im US-Format steht (sonst Endlosschleife)
  function datumDeutsch(wurzel) {
    wurzel.querySelectorAll('.jdgm-carousel-item__timestamp, .jdgm-rev__timestamp').forEach(function (el) {
      var m = (el.textContent || '').trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (m) el.textContent = ('0' + m[2]).slice(-2) + '.' + ('0' + m[1]).slice(-2) + '.' + m[3];
    });
  }

  function bewertungen(wurzel) {
    if (!wurzel || !wurzel.querySelectorAll) return;
    datumDeutsch(wurzel);
    // Judge.me schreibt seine Inhalte nach dem Laden (und beim Blättern) neu – dann erneut umstellen
    if (wurzel === document && 'MutationObserver' in window) {
      document.querySelectorAll('.jdgm-widget, .jdgm-carousel-wrapper').forEach(function (w) {
        if (w.__naBeob) return;
        w.__naBeob = true;
        var wartet = false;
        new MutationObserver(function () {
          if (wartet) return;
          wartet = true;
          requestAnimationFrame(function () { wartet = false; datumDeutsch(w); bewertungen(w); });
        }).observe(w, { childList: true, subtree: true, characterData: true });
      });
    }
    // Durchschnitt groß neben die Sterne (Wert kommt von Judge.me selbst)
    wurzel.querySelectorAll('.jdgm-all-reviews-rating[data-score]').forEach(function (el) {
      if (el.__naZahl) return;
      el.__naZahl = true;
      var wert = parseFloat(el.getAttribute('data-score'));
      if (!(wert > 0)) return;
      var zahl = document.createElement('span');
      zahl.className = 'na-bew-zahl';
      zahl.textContent = (Math.round(wert * 10) / 10).toFixed(1).replace('.', ',');
      el.parentNode.insertBefore(zahl, el);
    });
    // Produktseite: Sterne unter dem Titel scrollen zu den Bewertungen
    if (wurzel === document) {
      document.querySelectorAll('.template--product .product__rating').forEach(function (s) {
        if (!s.querySelector('svg') || s.__naKlick) return;
        s.__naKlick = true;
        s.setAttribute('data-na-zu-bewertungen', '');
        s.setAttribute('role', 'link');
        s.setAttribute('tabindex', '0');
        s.setAttribute('aria-label', 'Zu den Bewertungen');
        var hin = function () {
          var ziel = document.querySelector('.jdgm-rev-widg') || document.querySelector('[id$="__na_bewertungen"]');
          if (!ziel) return;
          var y = ziel.getBoundingClientRect().top + window.scrollY - 90;
          window.scrollTo({ top: y, behavior: ruhig ? 'auto' : 'smooth' });
        };
        s.addEventListener('click', hin);
        s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); hin(); } });
      });
    }
  }

  /* ------------------------------------------------------------------------
     Insta-Karussell wie bei Die Fiedel: die Beiträge wie Plattenhüllen, der mittlere groß, die Nachbarn schräg.
     Beim Hereinwischen fächert sich der Stapel auf, dann bleibt der Abschnitt stehen und ein Beitrag nach dem
     anderen gleitet in die Mitte. Ruhig (Bewegung reduzieren): eine Reihe zum seitlichen Wischen.
     ------------------------------------------------------------------------ */
  function instaKarussell() {
    var bahn = document.querySelector('[data-na-insta]');
    if (!bahn) return;
    var posten = Array.prototype.slice.call(bahn.querySelectorAll('.na-ik__post'));
    var n = posten.length;
    var text = bahn.querySelector('.na-ik__text');
    var band = bahn.querySelector('.na-ik__band');
    var texte = posten.map(function (p) { return p.getAttribute('data-text') || ''; });
    var klemme = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
    var weich = function (x) { return x * x * (3 - 2 * x); };
    var rasten = function (f) { var i = Math.floor(f); var x = f - i; return i + x - (Math.sin(2 * Math.PI * x) / (2 * Math.PI)) * 0.72; };

    function lage(i, f, e) {
      var dv = i - f, a = Math.abs(dv), s = dv < 0 ? -1 : dv > 0 ? 1 : 0;
      var x = s * (a <= 1 ? a * 0.64 + Math.sin(Math.PI * a) * 0.14 : 0.64 + (a - 1) * 0.3);
      var r = -s * Math.min(a, 1) * 52;
      var z = -Math.min(a, 3.2) * 0.34;
      var d = a > 3.4 ? 0 : 1 - Math.max(0, a - 2.4);
      var st = Math.min(i, 5);
      var mitte = Math.round(f);
      return {
        x: x * e + (1 - e) * st * 0.035,
        z: z * e - (1 - e) * (0.12 + st * 0.07),
        r: r * e,
        y: (1 - e) * 0.16,
        d: d * e + (i < 5 ? 1 : 0) * (1 - e),
        n: Math.min(1, a * 0.6) * e,
        zi: i === mitte ? 100 : i < mitte ? 10 + i : 10 + (n - 1 - i)
      };
    }

    // Handy: abgespeckter Flug (ohne Spiegelung/Abdunkeln) – dieselbe Bedingung wie im CSS
    var handy = !!(window.matchMedia && window.matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse)').matches);
    // Bilder erst holen, wenn man sich nähert (gut eine Bildschirmhöhe vorher)
    var geholt = false;
    var holen = function () {
      if (geholt) return;
      geholt = true;
      bahn.querySelectorAll('img[data-src]').forEach(function (b) {
        if (handy && b.closest('.na-ik__spiegel')) return; // Spiegelung ist am Handy aus – Bild gar nicht erst laden
        b.addEventListener('error', function () { b.style.visibility = 'hidden'; }, { once: true });
        if (b.getAttribute('data-srcset')) b.srcset = b.getAttribute('data-srcset');
        b.src = b.getAttribute('data-src');
        if (b.decode) b.decode().catch(function () {});
      });
    };

    var flugAn = !ruhig && n > 1 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    bahn.setAttribute('data-modus', flugAn ? 'flug' : 'still');
    var nah = false, raf = 0, fJetzt = 0, eJetzt = 1, zuletzt = 0, textNr = -1, erstesMal = true, ruhigeBilder = 0;
    var gesetzt = posten.map(function () { return { zi: '', zeiger: '', mitte: '' }; });

    function stellen(f, e) {
      posten.forEach(function (el, i) {
        var l = lage(i, f, e);
        var st = el.style;
        st.setProperty('--x', l.x.toFixed(4));
        st.setProperty('--z', l.z.toFixed(4));
        st.setProperty('--r', l.r.toFixed(2));
        st.setProperty('--y', l.y.toFixed(4));
        st.setProperty('--d', l.d.toFixed(3));
        if (!handy) st.setProperty('--n', l.n.toFixed(3));
        var g = gesetzt[i];
        var zi = String(l.zi);
        var zeiger = l.d < 0.05 ? 'none' : '';
        var mitte = Math.abs(i - f) < 0.5 && e > 0.9 ? '1' : '0';
        if (g.zi !== zi) { st.zIndex = zi; g.zi = zi; }
        if (g.zeiger !== zeiger) { st.pointerEvents = zeiger; g.zeiger = zeiger; }
        if (g.mitte !== mitte) { el.setAttribute('data-mitte', mitte); g.mitte = mitte; }
      });
      if (e > 0.35 && !bahn.hasAttribute('data-da')) bahn.setAttribute('data-da', '1');
      var nr = klemme(Math.round(f), 0, n - 1);
      if (text) {
        if (nr !== textNr) { textNr = nr; text.textContent = texte[nr] || ''; }
        text.style.opacity = ((1 - Math.min(1, Math.abs(f - nr) * 2.6)) * klemme((e - 0.6) / 0.4, 0, 1)).toFixed(3);
      }
    }
    function soll() {
      var r = bahn.getBoundingClientRect();
      var h = window.innerHeight;
      var p = klemme(-r.top / Math.max(1, r.height - h), 0, 1);
      return { f: rasten(p * (n - 1)), e: weich(klemme(1 - r.top / (h * 0.85), 0, 1)) };
    }
    function schritt(zeit) {
      raf = 0;
      if (!nah || !flugAn) return;
      var z = soll();
      var dt = zuletzt ? Math.min(64, zeit - zuletzt) : 16;
      zuletzt = zeit;
      var erst = erstesMal;
      erstesMal = false;
      // große Sprünge (Anker, Neuladen) nicht sichtbar durchgleiten, sonst leicht nachgleiten
      // (Zeitkonstante 50 ms statt 85 – die Beiträge folgen dem Finger spürbar direkter)
      var k = erst || Math.abs(z.f - fJetzt) > 2.5 ? 1 : 1 - Math.exp(-dt / 50);
      var fN = fJetzt + (z.f - fJetzt) * k;
      var eN = eJetzt + (z.e - eJetzt) * k;
      var still = Math.abs(fN - fJetzt) < 1e-4 && Math.abs(eN - eJetzt) < 1e-4 && Math.abs(z.f - fN) < 1e-3 && Math.abs(z.e - eN) < 1e-3;
      fJetzt = Math.abs(z.f - fN) < 1e-3 ? z.f : fN;
      eJetzt = Math.abs(z.e - eN) < 1e-3 ? z.e : eN;
      if (erst || !still) { stellen(fJetzt, eJetzt); ruhigeBilder = 0; } else ruhigeBilder++;
      if (ruhigeBilder < 20) raf = requestAnimationFrame(schritt);
    }
    function wecken() {
      if (!flugAn || !nah || raf) return;
      zuletzt = 0;
      raf = requestAnimationFrame(schritt);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (eintraege) {
        var e = eintraege[eintraege.length - 1];
        if (e.isIntersecting) holen();
        nah = e.isIntersecting;
        wecken();
      }, { rootMargin: '120% 0px 120% 0px' }).observe(bahn);
    } else { holen(); nah = true; }
    // Teil I: Bilder schon vorladen, wenn die Seite fertig ist und Ruhe herrscht – nicht erst kurz davor
    var vorladen = function () {
      var los = function () { if (!(navigator.connection && navigator.connection.saveData)) holen(); };
      if (window.requestIdleCallback) requestIdleCallback(los, { timeout: 4000 }); else setTimeout(los, 2500);
    };
    if (document.readyState === 'complete') vorladen(); else window.addEventListener('load', vorladen, { once: true });
    // ruhige Reihe mit Maus: Pfeile blättern
    bahn.addEventListener('click', function (ev) {
      var knopf = ev.target.closest && ev.target.closest('[data-richtung]');
      if (!knopf || !band) return;
      var breite = posten[0] ? posten[0].offsetWidth : 300;
      band.scrollBy({ left: Number(knopf.getAttribute('data-richtung')) * (breite + 16) * 2, behavior: ruhig ? 'auto' : 'smooth' });
    });
    if (flugAn) {
      if (soll().e > 0.35) bahn.setAttribute('data-da', '1');
      window.addEventListener('scroll', wecken, { passive: true });
      window.addEventListener('resize', wecken);
      // Tastatur: angesteuerter Beitrag kommt in die Mitte
      posten.forEach(function (el, i) {
        el.addEventListener('focus', function () {
          if (!el.matches(':focus-visible')) return;
          var r = bahn.getBoundingClientRect();
          window.scrollTo({ top: r.top + window.scrollY + (i / Math.max(1, n - 1)) * (r.height - window.innerHeight), behavior: 'auto' });
        });
      });
      wecken();
    }
  }

  /* ------------------------------------------------------------------------
     „Passt dazu“: leeren Bereich nie zeigen
     ------------------------------------------------------------------------ */
  function leereVorschlaegeVerstecken() {
    document.querySelectorAll('product-recommendations[data-recommendation-area]').forEach(function (pr) {
      var hatEintraege = pr.querySelector('.product-recommendations__item');
      if (!hatEintraege && !pr.classList.contains('hidden')) pr.classList.add('hidden');
    });
  }

  /* ------------------------------------------------------------------------
     Flug in den Warenkorb
     ------------------------------------------------------------------------ */
  function warenkorbZiel() {
    var ziele = document.querySelectorAll('[data-cart-link], .header__icon--cart, a[href="/cart"]');
    for (var i = 0; i < ziele.length; i++) {
      var r = ziele[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return ziele[i];
    }
    return null;
  }

  function fliegen(quelleImg) {
    if (ruhig || !quelleImg || !quelleImg.getBoundingClientRect) return;
    var ziel = warenkorbZiel();
    if (!ziel) return;
    var a = quelleImg.getBoundingClientRect();
    var z = ziel.getBoundingClientRect();
    if (!a.width) return;
    var groesse = Math.min(140, a.width);
    var flieger = document.createElement('img');
    flieger.className = 'na-flieger';
    flieger.src = quelleImg.currentSrc || quelleImg.src;
    flieger.alt = '';
    flieger.style.width = groesse + 'px';
    flieger.style.height = groesse + 'px';
    flieger.style.left = (a.left + a.width / 2 - groesse / 2) + 'px';
    flieger.style.top = (a.top + a.height / 2 - groesse / 2) + 'px';
    document.body.appendChild(flieger);
    var dx = (z.left + z.width / 2) - (a.left + a.width / 2);
    var dy = (z.top + z.height / 2) - (a.top + a.height / 2);
    var anim = flieger.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 120) + 'px) scale(.75) rotate(-25deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(-60deg)', opacity: .6 }
    ], { duration: 850, easing: 'cubic-bezier(.45,.05,.55,.95)' });
    anim.onfinish = function () {
      flieger.remove();
      ziel.classList.remove('na-wackeln');
      void ziel.offsetWidth;
      ziel.classList.add('na-wackeln');
    };
  }

  function bildZu(element) {
    var karte = element.closest('product-card, .product-recommendations__item');
    if (karte) return karte.querySelector('img');
    var seite = document.querySelector('.product__media img, [class*="media-gallery"] img, .product img');
    return seite;
  }

  // Formular-Absenden (Karten und Produktseite) – nur beobachten, nie eingreifen
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (f.matches('form.product-card__add-to-cart--form, form[action*="/cart/add"], product-form form')) {
      fliegen(bildZu(f));
    }
  }, true);

  /* ------------------------------------------------------------------------
     „Passt dazu“: einfache Aufkleber mit einem Klick hinzufügen
     ------------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest && e.target.closest('.na-passt-dazu-add');
    if (!knopf) return;
    e.preventDefault();
    e.stopPropagation();
    if (knopf.disabled) return;
    knopf.disabled = true;

    var drawer = document.querySelector('cart-drawer');
    var abschnitte = [];
    try {
      if (drawer && drawer.getSectionsToRender) abschnitte = drawer.getSectionsToRender().map(function (s) { return s.section; });
    } catch (err) { abschnitte = []; }

    fliegen(bildZu(knopf));

    var url = ((window.routes && routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(knopf.getAttribute('data-variant-id')), quantity: 1 }],
        sections: abschnitte,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (antwort) {
        if (antwort && antwort.status && antwort.status >= 400) throw new Error(antwort.description || 'Fehler');
        if (drawer && drawer.renderContents && antwort.sections) drawer.renderContents(antwort);
        if (typeof updateCartCounters === 'function') updateCartCounters();
        if (typeof updateFreeShipping === 'function') updateFreeShipping();
      })
      .catch(function () {
        knopf.disabled = false;
        knopf.textContent = 'Nochmal versuchen';
      });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
